import { Link, useNavigate } from "react-router-dom";

// import { EllipsisVertical, LogOut, Send, User } from 'lucide-react'

import { EllipsisVertical, LogOut, Send, User } from "lucide-react";

import { useAuth } from "../../../app/hooks/useAuth";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../components/ui/dropdown-menu";
import { BasicAvatar } from "../../components/BasicAvatar";
import { UserRoleDicionary } from "../../../app/services/usersService/user";
import { onlyFirstName } from "@/app/utils/onlyFirstName";
import { useWhitelabelContext } from "@/app/contexts/whitelabelContext";
// import { Calendar } from 'iconsax-react'

interface PersonalMenuProps {
  onNotificationClick: () => void;
  handleImportData: () => void;
}

export const PersonalMenu = ({
  onNotificationClick,
  // handleImportData,
}: PersonalMenuProps) => {
  const navigate = useNavigate();

  const { user, signout, isAdmin } = useAuth();
  const { appConfig } = useWhitelabelContext();
  // const { user, isSuperAdmin, signout } = useAuth()

  const handleLogOut = () => {
    signout();
    navigate("/");
  };

  return (
    <div className="hidden w-full xl:block">
      <div className="flex w-full items-center">
        <div className="flex w-full items-center justify-between bg-white02 p-5">
          <div className="flex items-center">
            <BasicAvatar
              name={user?.name}
              profileImageUrl={user?.profileImageUrl}
            />
            <div className="ml-2 mr-4">
              <p className="font-semibold">
                {onlyFirstName((user?.name && user.name) || "Usuário")}
              </p>
              <p className="text-[10px] font-medium text-black04">
                {user?.role ? UserRoleDicionary[user.role] : ""}
              </p>
            </div>
          </div>
          <DropdownMenu>
            <DropdownMenuTrigger>
              <EllipsisVertical className="cursor-pointer" />
            </DropdownMenuTrigger>
            <DropdownMenuContent className="mr-72 mt-4 w-64">
              <DropdownMenuLabel className="p-4">
                <p className="text-sm font-medium">{user?.name}</p>
                <p className="text-[10px] font-medium text-black04">
                  {user?.email}
                </p>
              </DropdownMenuLabel>
              {isAdmin && appConfig?.CAN_SEND_NOTIFICATION && (
                <>
                  <DropdownMenuItem
                    className="flex cursor-pointer gap-2 p-4"
                    onClick={onNotificationClick}
                  >
                    <Send />
                    <p className="text-sm font-medium">Enviar notificação</p>
                  </DropdownMenuItem>
                </>
              )}
              {/* {isSuperAdmin && (
                <DropdownMenuItem
                  className="flex cursor-pointer gap-2 p-4"
                  onClick={onNotificationClick}
                >
                  <Send />
                  <p className="text-sm font-medium">Enviar notificação</p>
                </DropdownMenuItem>
              )}

              {isSuperAdmin && (
                <DropdownMenuItem
                  className="flex cursor-pointer gap-2 p-4"
                  onClick={handleImportData}
                >
                  <Calendar />
                  <p className="text-sm font-medium">Agendar consulta CPFs</p>
                </DropdownMenuItem>
              )} */}

              <DropdownMenuItem className="cursor-pointer p-4">
                <Link
                  className="flex items-center gap-2"
                  to={`/perfil/${user?._id}`}
                >
                  <User />
                  <p className="text-sm font-medium">Editar perfil</p>
                </Link>
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                onClick={handleLogOut}
                className="flex cursor-pointer gap-2 p-4"
              >
                <LogOut />
                <p className="text-sm font-medium">Sair</p>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </div>
  );
};
